module.exports = __webpack_public_path__ + "static/media/cochinshipyard.96b01a03.svg";